import {
  Button,
  createMuiTheme,
  Grid,
  InputAdornment,
  InputBase,
  makeStyles,
  TextField,
  Typography,
  Popover,
  List,
  Link,
  ListItem,
  InputLabel,
  Tooltip,
  FormControlLabel,
  Radio,
  Backdrop,
  RadioGroup,
  Modal,
  FormControl,
  Fade,
} from "@material-ui/core";
import { FilterList, Search, Settings } from "@material-ui/icons";
import { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router";
import MaterialTable from "material-table";
import DataService from "../../../../../Service";
import { useSelector } from "react-redux";
import commonReducer from "../../../../../Redux/commonReducer";
import SearchIcon from "@material-ui/icons/Search";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";

const Coaches = (props) => {
  const directCoachDetail = useSelector((state) => state.commonReducer)
    ?.accessPermission?.assignmentDetail?.coaches?.directCoachDetail;

  const classes = useStyles();
  const [userData, setUserData] = useState([]);
  const history = useHistory();
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalCount, setTotalCount] = useState(100);
  const [isLoading, setIsLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [filter, setFilter] = useState("All");
  const [currentSelection, setcurrentSelection] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const moduleSetup = () => {
    const params = {
      //   page: page + 1 || 1,
      count_per_page: pageSize || 20,
      search: searchText || null,
      organisation_id: props.organisationId,
      filter: filter,
    };

    setIsLoading(true);
    DataService.getDirectData(
      `/coach_panels/listing_internal_coach_list`,
      params
    ).then((res) => {
      setIsLoading(false);
      console.log(res);
      if (res.success) {
        setTotalCount(res["total_count"]);
        let moduleSetups = res["internal_coach_lists"];
        setUserData(moduleSetups);
      }
    });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      moduleSetup();
    }, 500);

    // clean up function
    return () => clearTimeout(timeoutId);
  }, [searchText, filter, props.organisationId]);
  const columns = [
    { field: "full_name", title: "Coach name" },
    { field: "gender", title: "Gender" },
    { field: "email", title: "Email" },
    { field: "phone", title: "Phone" },
    {
      field: "location",
      title: "Location",
      headerStyle: {
        color: "#077F83",
      },
    },
    {
      title: "Assignments assigned",
      field: "attributes",
      actions: [
        {
          icon: () => "save",
          tooltip: "Save User",
          onClick: (event, rowData) => {
            // Do save operation
          },
        },
      ],
    },
  ];
  const options = {
    maxBodyHeight: "600px",
    pageSizeOptions: [20, 50, 75, 100],
    headerStyle: {
      fontWeight: "bold",
      color: "#077F83",
      position: "sticky",
      top: "0",
    },
    cellStyle: { fontSize: 14 },
    // actionsCellStyle: {minWidth:"10%",},
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    toolbar: false,
    search: false,
    total: totalCount,
    pageSize: 20,
    tableLayout: "fixed",
    rowStyle: {
      width: "100%",
      overflow: "hidden",
    },
  };
  // const theme = createMuiTheme({
  //   overrides: {},
  // });
  const viewProfileClick = ({ data: rowData }) => {
    console.log(rowData, "row data");
    // history.push(directCoachDetail ? "/CoachDetail" : "profile", {
    history.push("/CoachDetail", {
      id: rowData.id,
      coachType: "internal",
      name: rowData.full_name,
      currentSelection: rowData,
      organisation_id: props.organisationId,
      organisation_name: props.organisationName,
    });
  };
  const profileClick = (value) => {
    history.push("/CoachDetail", {
      id: currentSelection.id,
      coachType: "internal",
      currentSelection,
      selectedRole: value.target.textContent,
    });
  };

  const actions = [
    {
      icon: () => {
        return "View profile";
      },
    },
  ];
  const roleModel = useCallback(
    () => (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={Boolean(currentSelection)}
        onClose={handleClose}
        closeAfterTransition
        onBlur={() => setcurrentSelection(null)}
      >
        <Fade in={Boolean(currentSelection)}>
          <div className={`${classes.paper} ${classes.modalInner}`}>
            <Typography variant="h1" className={classes.headerStyle}>
              Choose Role
            </Typography>
            <FormControl
              component="fieldset"
              style={{ marginTop: 20, marginBottom: 20 }}
            >
              <RadioGroup aria-label="role" name="role">
                {currentSelection?.roles
                  ?.filter((el) => el.includes("Internal"))
                  .map((option) => {
                    return (
                      <FormControlLabel
                        style={{ textTransform: "capitalize" }}
                        value={option}
                        control={<Radio />}
                        onClick={profileClick}
                        label={
                          <Typography variant="subtitle1">{option}</Typography>
                        }
                      />
                    );
                  })}
              </RadioGroup>
            </FormControl>
          </div>
        </Fade>
      </Modal>
    ),
    [classes.modal, classes.modalInner, classes.paper, currentSelection?.roles]
  );
  const filterArray = [
    { id: "All", name: "All" },
    { id: "Assessor", name: "Internal Assessor" },
    { id: "Internal Coach", name: "Internal Coach" },
    { id: "Facilitator", name: "Internal Facilitator" },
    { id: "Mentor", name: "Internal Mentor" },
    { id: "Mediator", name: "Mediator" },
  ];
  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.header}>
          <Typography
            style={{
              paddingTop: "13px",
              fontWeight: "bold",
              marginBottom: "1rem",
            }}
            variant="h1"
            color="primary"
          >
            Internal coaches
          </Typography>
        </div>
        <Grid container direction="row" alignItems="center" justify="center">
          <Grid
            item
            xs={12}
            // style={{ margin: "25px 0", backgroundColor: "#fff" }}
          >
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="center"
            >
              <Grid item xs={6} style={{ marginBottom: "1rem" }}>
                <Grid container direction="row" alignItems="flex-end">
                  {/* <Grid item>
                  <Search />
                </Grid> */}
                  <Grid item xs={6}>
                    {/* <TextField
                    id="input-with-icon-grid"
                    label="Search"
                    variant="outlined"
                    onChange={(e) => setSearchText(e.target.value)}
                    InputLabelProps={{ style: { fontSize: "16px", fontFamily: "Open Sans" } }}
                    inputProps={{ style: { fontSize: "16px", fontFamily: "Open Sans" } }}
                  /> */}
                    <TextField
                      variant="outlined"
                      style={{
                        width: "273px",
                        marginTop: "14px",
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        style: { fontSize: "16px", fontFamily: "Open Sans" },
                      }}
                      type="search"
                      value={searchText}
                      placeholder="Search"
                      onChange={(event) => setSearchText(event.target.value)}
                    >
                      {" "}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <div style={{ float: "right" }}>
                  <Button
                    disableElevation
                    style={{ marginRight: 20, textTransform: "none" }}
                    variant="contained"
                    color="secondary"
                    onClick={handleClick}
                    startIcon={<FilterList />}
                    className={classes.f12}
                  >
                    {filterArray.filter((el) => el.id === filter)[0]?.name ||
                      ""}
                  </Button>
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                  >
                    <List component="nav" aria-label="main mailbox folders">
                      {filterArray.map((e) => (
                        <Link
                          onClick={() => {
                            setFilter(e.id);
                            handleClose();
                          }}
                        >
                          <ListItem style={{ paddingBottom: 0, paddingTop: 0 }}>
                            <InputLabel
                              style={{
                                marginLeft: 20,
                                minWidth: 100,
                                cursor: "pointer",
                              }}
                            >
                              <h4>{e.name}</h4>
                            </InputLabel>
                          </ListItem>
                        </Link>
                      ))}
                    </List>
                  </Popover>
                  {/* <Button
                  disableElevation
                  variant="contained"
                  color="secondary"
                  style={{ textTransform: "none" }}
                  startIcon={<Settings />}
                  className={classes.f12}
                >
                  Customize
                </Button> */}
                </div>
              </Grid>
            </Grid>
            <Grid direction="row">
              <Grid xs={12}>
                <MaterialTable
                  title=""
                  columns={columns}
                  actions={actions}
                  data={userData}
                  options={options}
                  totalCount={totalCount}
                  isLoading={isLoading}
                  components={{
                    Actions: (propsAction) => {
                      return (
                        <Tooltip
                          title={<TooltipWrapper text="View user profile" />}
                        >
                          <Button
                            onClick={() => {
                              const rowData = propsAction.data;
                              if (rowData?.roles?.length > 1) {
                                setcurrentSelection(rowData);
                              } else {
                                history.push("/CoachDetail", {
                                  id: rowData.id,
                                  coachType: "internal",
                                  currentSelection: rowData,
                                  selectedRole: rowData?.roles
                                    ? rowData?.roles[0]
                                    : "",
                                });
                              }
                            }}
                            disableElevation
                            variant="contained"
                            color="secondary"
                            className={`${classes.btnSearch}`}
                          >
                            View profile
                          </Button>
                        </Tooltip>
                      );
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {currentSelection?.roles && roleModel()}
    </>
  );
};
export default Coaches;

const useStyles = makeStyles((theme) => {
  return {
    wrapper: {
      padding: "5%",
      paddingTop: "0px",
      marginTop: "2rem",
    },
    bgGray: {
      backgroundColor: "#F7F7F7",
      padding: 20,
    },
    btnComplete: {
      backgroundColor: "#077F83",
      textTransform: "capitalize",
      fontSize: 14,
      marginRight: 20,
    },
    btnSearch: {
      marginRight: "1rem",
      width: "100%",
      // backgroundColor: "#077F83",
      textTransform: "none",
      fontSize: 12,
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 20,
    },
    paper: {
      backgroundColor: "#fff",
      boxShadow: theme.shadows[5],
      padding: 20,
      textAlign: "left",
    },
    modalInner: {
      width: 600,
      borderRadius: 10,
      maxHeight: 500,
      overflow: "auto",
    },
    f12: { fontSize: 12 },
  };
});
